(function() {

    let forInput = document.querySelector('[name="form-for"]');
    let forImage = document.querySelector('.contacts-form-image');
    let forButtons = document.querySelectorAll('.contacts-form-button');

    const params = new URLSearchParams(window.location.search);
    if (params.get('for') === 'for-partners') {
        console.log(params.get('for'));
        const button = document.querySelector('.contacts-form-button[data-id="for-partners"]');
        if (button) {
            let value = button.getAttribute('data-value');
            let image = button.getAttribute('data-image');

            forButtons.forEach(function (item){
                item.classList.remove('active');
            });
            button.classList.add('active');

            if (forInput) {
                forInput.value = value;
            }

            if (forImage) {
                forImage.style.backgroundImage = "url('" + image + "')";
            }
        }
    }

    let form = document.getElementById('contact-form');

    if (forButtons) {
        forButtons.forEach(function (button) {
            button.addEventListener('click', function() {
                let value = this.getAttribute('data-value');
                let image = this.getAttribute('data-image');

                forButtons.forEach(function (item){
                    item.classList.remove('active');
                });
                button.classList.add('active');

                if (forInput) {
                    forInput.value = value;
                }

                if (forImage) {
                    forImage.style.backgroundImage = "url('" + image + "')";
                }
            });
        });
    }

    let selects = document.querySelectorAll('.form-select');

    function closeAllSelects() {
        selects.forEach(function (select) {
            select.classList.remove('active');
        });
    }

    document.addEventListener('click', function(event) {
        let select = event.target.closest('.form-select');
        if (!event.target.classList.contains('js-select-multi')) {
            if (select && !event.target.classList.contains('js-appeal-select-item')) {
                if (select.classList.contains('active')) {
                    select.classList.remove('active');
                    closeAllSelects();
                } else {
                    closeAllSelects();
                    select.classList.add('active');
                }
            } else {
                closeAllSelects();
            }
        }
    });

    let groupSalesPoint = form.querySelector('.js-form-group[data-name="form-sales-point"]');
    let groupProductType = form.querySelector('.js-form-group[data-name="form-product-type"]');
    let groupProductWrong = form.querySelector('.js-form-group[data-name="form-product-wrong"]');
    let groupProductName = form.querySelector('.js-form-group[data-name="form-product-name"]');
    let groupProductPackaging = form.querySelector('.js-form-group[data-name="form-product-packaging"]');
    let groupSubject = form.querySelector('.js-form-group[data-name="form-subject"]');
    let groupEssence = form.querySelector('.js-form-group[data-name="form-essence"]');
    let selectItems = document.querySelectorAll('.form-select-list li');
    if (selectItems) {
        selectItems.forEach(function(item) {
            item.addEventListener('click', function() {
                let select = item.closest('.form-select');
                let input = select.querySelector('.form-select-input');
                let result = select.querySelector('.form-select-value');

                if (item.classList.contains('js-select-multi')) {
                    item.classList.contains('active') ? item.classList.remove('active') : item.classList.add('active');
                    let selectItemsActive = select.querySelectorAll('.form-select-list li.active');

                    let values = [];
                    let ids = [];

                    selectItemsActive.forEach(function(li) {
                        values.push(li.innerText);
                        ids.push(li.getAttribute('data-value'));
                    });

                    result.textContent = values.join(', ');
                    input.value = ids.join(',');
                } else {
                    let selectItemsActive = select.querySelectorAll('.form-select-list li.active');

                    result.textContent = item.innerText;
                    input.value = item.getAttribute('data-value');

                    selectItemsActive.forEach(function(li) {
                        li.classList.remove('active');
                    });

                    item.classList.add('active');
                    let value = item.getAttribute('data-value');

                    if (item.classList.contains('js-appeal-select-item')) {
                        runSelectAppeal(item);

                        groupProductType.classList.add('hidden');
                        groupProductWrong.classList.add('hidden');
                        groupProductName.classList.add('hidden');
                        groupProductPackaging.classList.add('hidden');
                    }

                    if (item.classList.contains('js-complaint-select-item')) {
                        runSelectComplaint(item);
                    }

                    if (item.classList.contains('js-country-select-item')) {
                        let fieldRegion = form.querySelector('.js-form-group[data-name="form-region"]');
                        if (parseInt(value) === 10188) {
                            fieldRegion.classList.remove('hidden');
                        } else {
                            fieldRegion.classList.add('hidden');
                        }
                    }

                    closeAllSelects();
                    setTimeout(closeAllSelects, 100);
                }
            });
        });
    }

    let inputProductPackaging = form.querySelectorAll('[name="form-product-packaging"]');
    if (inputProductPackaging) {
        inputProductPackaging.forEach(function(radioButton) {
            radioButton.addEventListener('click', function () {
                let groupProductDetails = form.querySelector('.js-form-group[data-name="form-details-of-product"]')
                this.value === 'yes' ? groupProductDetails.classList.remove('hidden') : groupProductDetails.classList.add('hidden');
            });
        });
    }

    function runSelectComplaint(item) {
        let value = parseInt(item.getAttribute('data-id'));

        groupSalesPoint.classList.add('hidden');
        groupProductType.classList.add('hidden');
        groupProductWrong.classList.add('hidden');
        groupProductName.classList.add('hidden');
        groupProductPackaging.classList.add('hidden');
        groupSubject.classList.add('hidden');
        groupEssence.classList.add('hidden');

        if (value === 1) {
            groupSalesPoint.classList.remove('hidden');
            groupSubject.classList.remove('hidden');
            groupEssence.classList.remove('hidden');
        }

        if (value === 2) {
            groupProductType.classList.remove('hidden');
            groupProductWrong.classList.remove('hidden');
            groupProductName.classList.remove('hidden');
            groupProductPackaging.classList.remove('hidden');
        }

        if (value === 3) {
            groupSubject.classList.remove('hidden');
            groupEssence.classList.remove('hidden');
        }
    }

    function runSelectAppeal(item) {

        let fields = form.querySelectorAll('.js-form-group');
        let fieldsShow = item.getAttribute('data-fields-show');
        let fieldsRequired = item.getAttribute('data-fields-required');

        if (fieldsShow) {
            fieldsShow = fieldsShow.split(',');
        }

        if (fieldsRequired) {
            fieldsRequired = fieldsRequired.split(',');
        }

        if (fields) {
            fields.forEach(function(field) {
                let name = field.getAttribute('data-name');

                if (fieldsShow && name !== 'form-details-of-product') {
                    fieldsShow.includes(name) ? field.classList.remove('hidden') : field.classList.add('hidden');
                } else {
                    field.classList.add('hidden');
                }

                let input = field.querySelector('input');
                let textarea = field.querySelector('textarea');
                if (input || textarea) {
                    input = input ? input : textarea;
                    if (fieldsRequired) {
                        fieldsRequired.includes(name) ? input.setAttribute('required', 'required') : input.removeAttribute('required');
                    } else {
                        input.removeAttribute('required')
                    }
                }
            });
        }
    }

    let appealActive = document.querySelector('.js-appeal-select-item.active');
    if (appealActive) {
        runSelectAppeal(appealActive);
    }

    let contactForm = document.getElementById('contact-form');
    if (contactForm) {
        let successBlock = document.querySelector('.form-success');
        let sectionContactsForm = document.querySelector('.section-contacts-form');

        contactForm.addEventListener('submit', function (event){
            event.preventDefault();

            let accept = contactForm.querySelector('[name=form-accept]');
            let acceptParent = accept.closest('.form-checkbox');
            acceptParent.classList.remove('error');

            if (!accept.checked) {
                acceptParent.classList.add('error');
                return;
            }

            contactForm.classList.add('opacity');
            let formData = new FormData(contactForm);
            fetch('/endpoint/contact-form/submit', getRequestOption('POST', formData))
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then(data => {
                    console.log(data);
                    contactForm.classList.remove('opacity');
                    contactForm.classList.add('hidden');
                    if (successBlock) {
                        successBlock.classList.add('active');
                        sectionContactsForm.scrollIntoView({ behavior: 'smooth' });
                    }
                })
                .catch(error => {
                    contactForm.classList.remove('opacity');
                    console.error('There was a problem with the fetch operation:', error);
                });
        });
    }

    function getRequestOption(method = 'POST', body = '') {
        let csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        return {
            method: method,
            body: body,
            headers: {
                'X-CSRF-Token': csrf
            },
        };
    }

})();
